export const getObjectById = <T extends Array<any>>(arr: T, id: string) => {
  return arr.find((item) => item.id === id);
};
